import { render, staticRenderFns } from "./cate.vue?vue&type=template&id=e0dab6fc&scoped=true&"
import script from "./cate.vue?vue&type=script&lang=js&"
export * from "./cate.vue?vue&type=script&lang=js&"
import style0 from "./cate.vue?vue&type=style&index=0&id=e0dab6fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0dab6fc",
  null
  
)

export default component.exports